module.exports = __webpack_public_path__ + "static/media/qwen.795902fa.svg";